/* collection/sagas */
import { all, fork, put, takeEvery } from "redux-saga/effects";
import { isEmpty } from "ramda";
import { PermissionActionTypes } from "./types";
import { fetch } from "../../repo/permission";
import { fetchError, fetchSuccess } from "./actions";

function* handleFetch() {
  try {
    const collection = yield fetch();
    if (collection.errors && !isEmpty(collection.errors)) {
      yield put(fetchError(JSON.stringify(collection.errors)));
    } else {
      yield put(fetchSuccess(collection));
    }
  } catch (err) {
    yield put(fetchError(err));
  }
}

function* watchFetchRequest() {
  yield takeEvery(PermissionActionTypes.FETCH, handleFetch);
}

export default function* collectionSaga() {
  yield all([fork(watchFetchRequest)]);
}
